"use strict";
/* global $ */
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
exports.__esModule = true;
exports.StructBlockDefinition = exports.StructBlock = exports.StructBlockValidationError = void 0;
var text_1 = require("../../../utils/text");
var StructBlockValidationError = /** @class */ (function () {
    function StructBlockValidationError(blockErrors) {
        this.blockErrors = blockErrors;
    }
    return StructBlockValidationError;
}());
exports.StructBlockValidationError = StructBlockValidationError;
var StructBlock = /** @class */ (function () {
    function StructBlock(blockDef, placeholder, prefix, initialState, initialError) {
        var _this = this;
        var state = initialState || {};
        this.blockDef = blockDef;
        this.type = blockDef.name;
        this.childBlocks = {};
        if (blockDef.meta.formTemplate) {
            var html = blockDef.meta.formTemplate.replace(/__PREFIX__/g, prefix);
            var dom_1 = $(html);
            $(placeholder).replaceWith(dom_1);
            this.blockDef.childBlockDefs.forEach(function (childBlockDef) {
                var childBlockElement = dom_1.find('[data-structblock-child="' + childBlockDef.name + '"]').get(0);
                var childBlock = childBlockDef.render(childBlockElement, prefix + '-' + childBlockDef.name, state[childBlockDef.name], initialError === null || initialError === void 0 ? void 0 : initialError.blockErrors[childBlockDef.name]);
                _this.childBlocks[childBlockDef.name] = childBlock;
            });
        }
        else {
            var dom_2 = $("\n        <div class=\"" + text_1.escapeHtml(this.blockDef.meta.classname || '') + "\">\n        </div>\n      ");
            $(placeholder).replaceWith(dom_2);
            if (this.blockDef.meta.helpText) {
                // help text is left unescaped as per Django conventions
                dom_2.append("\n          <span>\n            <div class=\"help\">\n              " + this.blockDef.meta.helpIcon + "\n              " + this.blockDef.meta.helpText + "\n            </div>\n          </span>\n        ");
            }
            this.blockDef.childBlockDefs.forEach(function (childBlockDef) {
                var childDom = $("\n          <div class=\"field " + (childBlockDef.meta.required ? 'required' : '') + "\" data-contentpath=\"" + childBlockDef.name + "\">\n            <label class=\"field__label\">" + text_1.escapeHtml(childBlockDef.meta.label) + "</label>\n            <div data-streamfield-block></div>\n          </div>\n        ");
                dom_2.append(childDom);
                var childBlockElement = childDom.find('[data-streamfield-block]').get(0);
                var labelElement = childDom.find('label').get(0);
                var childBlock = childBlockDef.render(childBlockElement, prefix + '-' + childBlockDef.name, state[childBlockDef.name], initialError === null || initialError === void 0 ? void 0 : initialError.blockErrors[childBlockDef.name]);
                _this.childBlocks[childBlockDef.name] = childBlock;
                if (childBlock.idForLabel) {
                    labelElement.setAttribute('for', childBlock.idForLabel);
                }
            });
        }
    }
    StructBlock.prototype.setState = function (state) {
        // eslint-disable-next-line guard-for-in, no-restricted-syntax
        for (var name_1 in state) {
            this.childBlocks[name_1].setState(state[name_1]);
        }
    };
    StructBlock.prototype.setError = function (errorList) {
        if (errorList.length !== 1) {
            return;
        }
        var error = errorList[0];
        // eslint-disable-next-line no-restricted-syntax
        for (var blockName in error.blockErrors) {
            if (error.blockErrors.hasOwnProperty(blockName)) {
                this.childBlocks[blockName].setError(error.blockErrors[blockName]);
            }
        }
    };
    StructBlock.prototype.getState = function () {
        var state = {};
        // eslint-disable-next-line guard-for-in, no-restricted-syntax
        for (var name_2 in this.childBlocks) {
            state[name_2] = this.childBlocks[name_2].getState();
        }
        return state;
    };
    StructBlock.prototype.getValue = function () {
        var value = {};
        // eslint-disable-next-line guard-for-in, no-restricted-syntax
        for (var name_3 in this.childBlocks) {
            value[name_3] = this.childBlocks[name_3].getValue();
        }
        return value;
    };
    StructBlock.prototype.getTextLabel = function (opts) {
        var e_1, _a;
        var _this = this;
        if (this.blockDef.meta.labelFormat) {
            /* use labelFormat - regexp replace any field references like '{first_name}'
            with the text label of that sub-block */
            return this.blockDef.meta.labelFormat.replace(/\{(\w+)\}/g, function (tag, blockName) {
                var block = _this.childBlocks[blockName];
                if (block.getTextLabel) {
                    /* to be strictly correct, we should be adjusting opts.maxLength to account for the overheads
                    in the format string, and dividing the remainder across all the placeholders in the string,
                    rather than just passing opts on to the child. But that would get complicated, and this is
                    better than nothing... */
                    return block.getTextLabel(opts);
                }
                return '';
            });
        }
        try {
            /* if no labelFormat specified, just try each child block in turn until we find one that provides a label */
            for (var _b = __values(this.blockDef.childBlockDefs), _c = _b.next(); !_c.done; _c = _b.next()) {
                var childDef = _c.value;
                var child = this.childBlocks[childDef.name];
                if (child.getTextLabel) {
                    var val = child.getTextLabel(opts);
                    if (val)
                        return val;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b["return"])) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        // no usable label found
        return null;
    };
    StructBlock.prototype.focus = function (opts) {
        if (this.blockDef.childBlockDefs.length) {
            var firstChildName = this.blockDef.childBlockDefs[0].name;
            this.childBlocks[firstChildName].focus(opts);
        }
    };
    return StructBlock;
}());
exports.StructBlock = StructBlock;
var StructBlockDefinition = /** @class */ (function () {
    function StructBlockDefinition(name, childBlockDefs, meta) {
        this.name = name;
        this.childBlockDefs = childBlockDefs;
        this.meta = meta;
    }
    StructBlockDefinition.prototype.render = function (placeholder, prefix, initialState, initialError) {
        return new StructBlock(this, placeholder, prefix, initialState, initialError);
    };
    return StructBlockDefinition;
}());
exports.StructBlockDefinition = StructBlockDefinition;
